import { createFileRoute } from '@tanstack/react-router';

import { ExpiredSessionPage } from '@/auth/pages/expired-session';

export const Route = createFileRoute('/expired-session')({
  component: ExpiredSessionRoute
});

function ExpiredSessionRoute() {
  return <ExpiredSessionPage/>;
}
